import type { FieldValidator } from '@/services/games/types'

/**
 * Validator for the sets/legs field. "Best of" play requires odd counts so a tie
 * is impossible; the SetsLegsSelector auto-corrects values, and this is the
 * safety net that blocks "Confirm" (and explains why) if something is still even.
 */
export const setsLegsFieldValidator: FieldValidator = (settings, ctx) => {
    if (settings.win_type !== 'best_of') {
        return null
    }

    const setsEven = Number(settings.sets_to_win) % 2 === 0
    const legsEven = Number(settings.legs_to_win) % 2 === 0

    if (ctx.setsLegsMode === 'sets') {
        if (setsEven && legsEven) {
            return 'match_setup.best_of_sets_legs'
        }
        if (setsEven) {
            return 'match_setup.best_of_sets'
        }
        if (legsEven) {
            return 'match_setup.best_of_legs'
        }
        return null
    }

    // 'legs' mode: only legs matter.
    return legsEven ? 'match_setup.best_of_legs' : null
}
